import { render } from "./CustomerDetail.vue?vue&type=template&id=1c7a1266"
import script from "./CustomerDetail.vue?vue&type=script&lang=js"
export * from "./CustomerDetail.vue?vue&type=script&lang=js"
script.render = render

export default script